import {Component} from "../interface/component";
import {inject, injectable} from "inversify";

// @ts-ignore
@injectable()
export class FacebookFeedsComponents implements Component {

    private $root:JQuery;

    init(elem:HTMLElement) {
        this.$root = $(elem);
        this.bindUI();
    }

    private bindUI() {
        this.$root.find('.js-feed__reauthenticate').on({ click: this.authenticate });
        let $feeds = this.$root.find('td.js-feeds__authenticated');
        $feeds.each((index:number, element:HTMLElement) => {
            let $feed = $(element).closest('tr');
            if ($feed.data('enabled')) {
                let feed_id = $feed.data('id');
                if (undefined !== feed_id) {
                    this.checkAuthentication(feed_id)
                        .then(
                            (response: any) => {
                                if (response.state == 'authenticated') {
                                    $(element).text('Active');
                                } else {
                                    $(element).text('Not authenticated');
                                }
                            },
                            err => console.log('error', err)
                        );
                }
            } else {
                $(element).text('n/a');
            }
        });
    }

    checkAuthentication = (feed_id:number) => {
        return new Promise<any>(
            resolve => {
                if (undefined !== feed_id) {
                    let params = { feed_id: feed_id };
                    $
                        .ajax({ url: '/admin/social/check-authentication', data: params, method: 'GET' })
                        .then(
                            (response) => {
                                try {
                                    resolve(JSON.parse(response))
                                } catch (err) {
                                    resolve(false);
                                }
                            },
                            () => resolve(false)
                        );
                } else {
                    resolve(false);
                }
            }
        );
    }

    authenticate = (ev:MouseEvent) => {
        ev.preventDefault();
        let $feed = $(ev.currentTarget).closest('tr');
        let feed_id = $feed.data('id');
        if ('facebook' === $feed.data('type')) {
            (<any>window).FB.login(
                (response: any) => {
                    if (response.authResponse) {
                        (<any>window).location.href = '/admin/social/reauthenticate?feed_id=' + feed_id + '&token=' + response.authResponse.accessToken;
                    } else {
                        alert('Something went wrong. Please try again.');
                    }
                }, {scope: 'email,pages_read_user_content,pages_manage_posts,pages_read_engagement'}
            );
        }
    }
}